<template>
  <v-card v-if="eventData" class="custom-timetable-card">
    <v-card-text class="pa-0 ma-0" v-if="isAppMode(['T40'])">
      <div
        class="custom-timetable-card__top"
        :style="{
          background: eventData.colorCode,
          color: lightColorOptions.includes(eventData.colorCode) ? '#3B3B3B' : '#ffffff',
        }"
      >
        <div class="d-flex align-start justify-space-between">
          <ul class="student-attendance-list" v-if="$validate.DataValid(eventData.student_data, true)">
            <li v-for="data in eventData.student_data" :key="data.id">
              <div class="attend-check mr-1" :class="data.attendance">
                <span v-if="data.attendance === 'await' || data.attendance === 'sick_leave'">請</span>
              </div>
              <div
                class="gender-dot mr-1"
                :class="data.gender === 'M' ? 'gender-m' : data.gender === 'F' ? 'gender-f' : ''"
              ></div>
              <span>
                <span
                  :class="{
                    'red--text': data.unpaid,
                    'accent--text': !data.unpaid && data.last_package_lesson,
                  }"
                  >{{ data.name }}</span
                >{{ _getStudentDes(data) }}
              </span>
              <div class="timetable-tag free-lesson" v-if="data.trial">試</div>
              <div class="timetable-tag new" v-if="data.new_student">NEW</div>
            </li>
          </ul>
          <div v-else></div>
          <span>{{
            $t('calendar.currentPerMaxStudent', {
              current: eventData.current_student_num,
              max: eventData.max_student === -1 ? $t('noLimit') : eventData.max_student,
            })
          }}</span>
        </div>
        <span>{{ eventData.start_time }}-{{ eventData.end_time }}</span>
      </div>

      <div class="custom-timetable-card__bot">
        <ul class="course-info-list">
          <li>{{ eventData.tutor || '' }}</li>
          <li class="course-info-remark" v-if="eventData.remark">
            <v-img
              src="~@/assets/images/remark.svg"
              alt="remark"
              width="12"
              height="12"
              max-width="12"
              max-height="12"
              contain
              class="mr-2"
            ></v-img>
            {{ $t('lessonRemark') }}{{ eventData.remark }}
          </li>
          <li v-if="eventData.classroom && !isAppMode(['T79'])">
            <v-icon color="colorBlack" size="12" class="fi fi-rr-door-open mr-2"></v-icon>{{ eventData.classroom }}
          </li>
          <li class="course-name">{{ eventData.course_name }}</li>
          <template v-if="showStatus">
            <li v-if="eventData.applied === true">
              <v-icon class="fi fi-br-check mr-1" color="success" size="12"></v-icon>{{ $t('lessonStatus.applied') }}
            </li>
            <li v-else-if="eventData.same === true">
              <v-icon class="fi fi-br-check mr-1" color="success" size="12"></v-icon>{{ $t('lessonStatus.same') }}
            </li>
          </template>
        </ul>
      </div>
    </v-card-text>
    <v-card-text class="pa-0 ma-0" v-else>
      <div
        class="custom-timetable-card__top"
        :style="{
          background: eventData.colorCode,
          color: lightColorOptions.includes(eventData.colorCode) ? '#3B3B3B' : '#ffffff',
        }"
      >
        <div class="d-flex align-start justify-space-between flex-wrap">
          <span>{{ eventData.tutor || '' }}</span>
          <span>{{
            $t('calendar.currentPerMaxStudent', {
              current: eventData.current_student_num,
              max: eventData.max_student === -1 ? $t('noLimit') : eventData.max_student,
            })
          }}</span>
        </div>
        <span>{{ eventData.start_time }}-{{ eventData.end_time }}</span>
      </div>

      <div class="custom-timetable-card__bot">
        <div class="course-name">{{ eventData.course_name }}</div>
        <ul class="course-info-list">
          <li v-if="eventData.grade">
            <v-icon color="colorBlack" size="12" class="fi fi-rr-graduation-cap mr-2"></v-icon>
            {{ gfGetGradeText(eventData.grade) }}
          </li>
          <li v-if="eventData.classroom">
            <v-icon color="colorBlack" size="12" class="fi fi-rr-door-open mr-2"></v-icon>{{ eventData.classroom }}
          </li>
        </ul>
        <ul
          class="student-attendance-list mt-2"
          v-if="$validate.DataValid(eventData.student_data)"
          v-show="expandStudent"
        >
          <li v-for="data in eventData.student_data" :key="data.id">
            <div class="attend-check" :class="data.attendance">
              <span v-if="data.attendance === 'await' || data.attendance === 'sick_leave'">請</span>
            </div>
            <div
              v-if="!isAppMode(['T02'])"
              class="gender-dot"
              :class="data.gender === 'M' ? 'gender-m' : data.gender === 'F' ? 'gender-f' : ''"
            ></div>
            <span>
              <span
                :class="{
                  'red--text': data.unpaid,
                  'accent--text': !data.unpaid && data.last_package_lesson,
                }"
                >{{ data.name }} </span
              >{{ _getStudentDes(data) }}
            </span>
            <div class="timetable-tag free-lesson" v-if="data.trial">試</div>
            <div class="timetable-tag new" v-if="data.new_student">NEW</div>
          </li>
        </ul>
        <ul class="course-info-list">
          <li class="course-info-remark" v-if="eventData.remark">
            <v-img
              src="~@/assets/images/remark.svg"
              alt="remark"
              width="12"
              height="12"
              max-width="12"
              max-height="12"
              contain
              class="mr-2"
            ></v-img>
            {{ $t('lessonRemark') }}{{ eventData.remark }}
          </li>
          <template v-if="showStatus">
            <li v-if="eventData.applied === true">
              <v-icon class="fi fi-br-check mr-1" color="success" size="12"></v-icon>{{ $t('lessonStatus.applied') }}
            </li>
            <li v-else-if="eventData.same === true">
              <v-icon class="fi fi-br-check mr-1" color="success" size="12"></v-icon>{{ $t('lessonStatus.same') }}
            </li>
          </template>
        </ul>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'TimetableEventCard',
  props: {
    eventData: {
      type: Object,
      default: null,
      required: true,
    },
    expandStudent: {
      type: Boolean,
      default: false,
      required: true,
    },
    showStatus: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({
    lightColorOptions: [
      '#A7FF00',
      '#2ED8F7',
      '#FADADD',
      '#F8C8DC',
      '#FFD6C9',
      '#FFE5B4',
      '#FFF4B8',
      '#FFF0C1',
      '#E2F7E1',
      '#DFF5E1',
      '#C7F0E9',
      '#D9F3F0',
      '#D6E8FF',
      '#CFE7F5',
      '#DDE7FF',
      '#E6D9FF',
    ],
  }),
  methods: {
    _getStudentDes(student) {
      let des = ''
      console.log(student)
      if (this.isAppMode(['T75'])) {
        if(student.birthday != undefined && student.birthday != null && student.birthday != ""){
          const birth = this.$formatter.convertDate(student.birthday)
          const today = this.$formatter.convertDate()
          let months = (Math.abs(today.getFullYear() - birth.getFullYear()) * 12) + today.getMonth() - birth.getMonth();
          // months = months%12
          let age = Math.floor(months/12)+"歲"+months%12+"月"//(months>0?"."+months:"")
          if(age != ''){
            des += ` (${age})`
          }
        }
        if(student.remark != undefined && student.remark != null && student.remark != ""){
          des += ` (${student.remark})`
        }
        if(student.student_field_2 != undefined && student.student_field_2 != null && student.student_field_2 != ""){
          des += ` (${student.student_field_2})`
        }
        
      }
      if (this.isAppMode(['T40']) && student.student_code) {
        des += ` (${student.student_code})`
      }
      if (student.package_quota_count) {
        des += ` ${student.package_quota_count}`
      }
      if (this.isAppMode(['T37', 'T45', 'T46']) && student.grade) {
        des += ` (${this.gfGetGradeText(student.grade)})`
      }
      if (this.isAppMode(['T45']) && student.birthday && this.$validate.regexDateStr(student.birthday)) {
        const birth = this.$formatter.convertDate(student.birthday)
        const today = this.$formatter.convertDate()
        let age = Math.abs(today.getFullYear() - birth.getFullYear())
        if (
          birth.getMonth() > today.getMonth() ||
          (birth.getMonth() === today.getMonth() && birth.getDate() > today.getDate())
        ) {
          age = age - 1
        }
        des += ` (${age})`
      }
      if (student.is_skip_to_lesson) {
        des += ' (補)'
      }
      console.log(student)
      if(student.is_switch_to_lesson || student.from_lesson){
        des += ' (轉)'
      }
      return des
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.custom-timetable-card {
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;

  & .custom-timetable-card__top {
    padding: 5px 10px;
    color: #ffffff;
    font-size: 0.75rem;
    line-height: 1.5;

    & .student-attendance-list {
      & > li {
        font-size: 0.75rem;
        color: inherit;

        & > span,
        & > span > span {
          color: inherit;
        }
      }
    }
  }

  & .custom-timetable-card__bot {
    color: var(--v-colorBlack-base);
    padding: 10px;
    background: #eeeeee;

    & .course-name {
      font-size: 0.75rem;
      line-height: 1.5;
      font-weight: 600;
      margin-bottom: 10px;
    }

    & > .course-info-list {
      padding: 0;
      list-style: none;

      & > li {
        position: relative;
        color: var(--v-colorBlack-base);
        font-size: 10px;
        margin: 5px 0;
        display: flex;
        align-items: flex-start;

        &.course-info-remark {
          color: #e89304;
          white-space: pre-line;
        }
      }
    }
  }

  & .student-attendance-list {
    padding: 0;
    list-style: none;

    & > li {
      position: relative;
      color: var(--v-colorBlack-base);
      font-size: 10px;
      margin: 5px 0;
      display: flex;
      align-items: center;
      line-height: 1;

      & > .attend-check {
        width: 10px;
        min-width: 10px;
        height: 10px;
        border-radius: 2px;
        background: #a7a7a7;
        margin-right: 8px;
        font-size: 7px;
        text-align: center;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;

        &.attend {
          background: #27c712;
        }

        &.absent {
          background: var(--v-red-base);
        }

        &.await,
        &.sick_leave {
          background: var(--v-accent-base);
        }
      }

      & > .timetable-tag {
        width: auto;
        text-align: center;
        font-size: 7px;
        min-width: 16px;
        border-radius: 2px;
        margin-left: 5px;
        line-height: 1;
        padding: 2px;
        color: #ffffff;

        &.free-lesson {
          background: var(--v-accent-base);
        }

        &.new {
          background: #2096f3;
        }
      }
    }
  }
}
.custom-timetable__week-grid {

    // & .v-card__text:not(:hover){
    //   & .custom-timetable-card__bot{
    //     display: none !important;
    //   }
    // }

    // .week-event-content
    .custom-timetable__week-event:not(:hover):not(.disable-hidden) {
      & .custom-timetable-card__bot{
        display: none !important;
      }
    }
    .week-event-content:hover {
      & .custom-timetable-card__bot{
        // display: none !important;
      }
    }
}
</style>
